import { render } from "./MobileSignApp.vue?vue&type=template&id=04f2c2c3&scoped=true"
import script from "./MobileSignApp.vue?vue&type=script&lang=js"
export * from "./MobileSignApp.vue?vue&type=script&lang=js"

import "./MobileSignApp.vue?vue&type=style&index=0&id=04f2c2c3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04f2c2c3"

export default script